import "./OmAveragePriceUpdateRequestDialogComponent.scss";
import {IComponentOptions} from "angular";
import template from "./OmAveragePriceUpdateRequestDialogComponent.html";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {EquityPositionViewModel} from "../../../../account/equity/models/EquityPositionViewModel";
import {AveragePriceUpdateRequestService} from "../../../../account/services/AveragePriceUpdateRequestService";
import {AveragePriceUpdateRequest} from "../../../../account/types/AveragePriceUpdateRequest";
import {SimpleModalService} from "../../../../types/SimpleModalService";

export const OMAveragePriceUpdateRequestDialog = "tfOmAveragePriceUpdateRequestDialog";

export function omAveragePriceUpdateRequestDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controllerAs: "ctrl",
        controller: OmAveragePriceUpdateRequestDialogComponentController
    };
}

interface Resolve {
    readonly position: EquityPositionViewModel;
}

export class OmAveragePriceUpdateRequestDialogComponentController {

    /** @input */
    public set resolve(resolve: Resolve) {
        if (resolve != null) {
            this.position = resolve.position;
        }
    }

    public position: EquityPositionViewModel | null;

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    public newAveragePrice: number | null;

    /** @ngInject */
    public constructor(private readonly averagePriceUpdateRequestService: AveragePriceUpdateRequestService,
                       private readonly simpleModalService: SimpleModalService) {

    }

    public async applyChanges() {
        if ((this.position != null) && (this.newAveragePrice != null)) {
            const request = this.averagePriceUpdateRequest(this.position, this.newAveragePrice);
            try {
                await this.averagePriceUpdateRequestService.requestAveragePriceUpdate(request);
                this.modalInstance.close();
            } catch (e) {
                await this.simpleModalService.alert("Please try again later or contact support.", "Unable to Request Price Change", "md");
            }
        }
    }

    private averagePriceUpdateRequest(position: EquityPositionViewModel,
                                      newAveragePrice: number): AveragePriceUpdateRequest {
        const code = position.code;
        const exchange = position.exchange;
        const accountId = position.accountId;
        const currentAveragePrice = position.averagePrice;
        const averagePriceUpdate = {
            currentAveragePrice,
            newAveragePrice
        };
        return {
            code,
            exchange,
            accountId,
            averagePriceUpdate
        };
    }

    public close() {
        this.modalInstance.dismiss();
    }
}
